(() => {
  class IngredientAccordionController extends Stimulus.Controller {
    static targets = ["item", "button", "content"]
    static values = {
      autoOpen: Boolean
    }
    
    connect() {
      this.initializeAccordion();
    }
    
    initializeAccordion() {
      // Close all answers initially
      this.contentTargets.forEach(content => {
        content.style.maxHeight = '0px';
      });

      // Remove any active classes that might be set in HTML
      this.itemTargets.forEach(item => {
        item.classList.remove('active');
      });
      
      // Check if we should auto-open the first item
      if (this.autoOpenValue && this.hasItemTarget && this.hasContentTarget) {
        // Small delay to ensure content is rendered
        setTimeout(() => {
          this.open(0);
        }, 10);
      }
    }
    
    toggle(event) {
      const button = event.currentTarget;
      const index = this.buttonTargets.indexOf(button);
      
      if (index !== -1) {
        const item = this.itemTargets[index];
        const isActive = item.classList.contains('active');
        
        // Close all items first
        this.closeAll();
        
        // If clicked item wasn't active, open it
        if (!isActive) {
          this.open(index);
        }
      }
      
      // Prevent default button behavior
      event.preventDefault();
    }
    
    open(index) {
      const item = this.itemTargets[index];
      const content = this.contentTargets[index];
      const innerContent = content.querySelector('.tab-content-inner');
      
      // Add active class to item
      item.classList.add('active');
      
      // Set max-height to scroll height for smooth animation
      if (innerContent) {
        const contentHeight = innerContent.offsetHeight;
        content.style.maxHeight = `${contentHeight}px`;
      }
    }
    
    closeAll() {
      this.itemTargets.forEach((item, i) => {
        item.classList.remove('active');
        this.contentTargets[i].style.maxHeight = '0px';
      });
    }
  }

  // Fixed registration code
    // Registration code remains unchanged
    document.addEventListener('DOMContentLoaded', () => {
      // Check how Stimulus is defined in your theme
      if (window.Stimulus) {
        if (window.Stimulus.application) {
          window.Stimulus.application.register('ingredient-accordion', IngredientAccordionController);
        } else if (window.Stimulus.Application) {
          const application = window.Stimulus.Application.start();
          application.register('ingredient-accordion', IngredientAccordionController);
        }
      } else if (window.application) {
        window.application.register('ingredient-accordion', IngredientAccordionController);
      } else if (window.StimulusApp) {
        if (typeof window.StimulusApp.register === 'function') {
          window.StimulusApp.register('ingredient-accordion', IngredientAccordionController);
        } else if (window.StimulusApp.application && typeof window.StimulusApp.application.register === 'function') {
          window.StimulusApp.application.register('ingredient-accordion', IngredientAccordionController);
        }
      } else {
        console.warn('Stimulus JS is not loaded or accessible. The ingredient accordion will not function.');
      }
    });
})();